import { ADD_MENU_ITEMS } from "../types/admin";

const initialState = {
  response: null,
};

const adminReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_MENU_ITEMS:
      return { ...state, response: payload };
    default:
      return state;
  }
};

export default adminReducer;
